import { useECommerceProduct } from "../../hooks/useECommerceProduct.hook";
import { Compare } from "./compare.component";

const CompareContainer = () => {
    const { sku, isAdditionalService, isBoxArticle } = useECommerceProduct();
    return (
        <Compare
            sku={sku}
            isAdditionalService={isAdditionalService}
            isBoxArticle={isBoxArticle}
        />
    );
};

export { CompareContainer };
